import { useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ScrollTabs } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import { LayoutDashboard, Users, ShieldCheck, UserPlus, Monitor } from 'lucide-react';
import UserManagementSideNav from './components/UserManagementSideNav.jsx';
import UserManagementRoutes from './routes/UserManagementRoutes.jsx';

/**
 * Root component of the User Management application.
 * Desktop: sidebar + content. Mobile: scrollable tab bar + content.
 */
const UserManagementApp = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t, ready } = useTranslation('user-management');

  const mobileNav = useMemo(
    () => [
      { path: '/users', icon: LayoutDashboard, labelKey: 'mobileNav.overview', exact: true },
      { path: '/users/list', icon: Users, labelKey: 'mobileNav.users' },
      { path: '/users/roles', icon: ShieldCheck, labelKey: 'mobileNav.roles' },
      { path: '/users/invitations', icon: UserPlus, labelKey: 'mobileNav.invitations' },
      { path: '/users/sessions', icon: Monitor, labelKey: 'mobileNav.sessions' },
    ],
    []
  );

  if (!ready) {
    return (
      <div className="flex flex-1 items-center justify-center text-sm text-content-muted">Loading…</div>
    );
  }

  return (
    <div className="flex h-full flex-1">
      <div className="hidden md:flex">
        <UserManagementSideNav />
      </div>

      <div className="flex flex-1 flex-col overflow-hidden">
        <ScrollTabs className="md:hidden">
          {mobileNav.map((item) => (
            <ScrollTabs.Item
              key={item.path}
              icon={item.icon}
              active={item.exact ? location.pathname === item.path : location.pathname.startsWith(item.path)}
              onClick={() => navigate(item.path)}
            >
              {t(item.labelKey)}
            </ScrollTabs.Item>
          ))}
        </ScrollTabs>

        <UserManagementRoutes />
      </div>
    </div>
  );
};

export default UserManagementApp;
